module.exports = __webpack_public_path__ + "img/1212c_3.94ae5423.jpg";